import { useMutation, useQueryClient } from 'react-query';
import { backend } from '../axios/backend';
import { useAppContext } from '../context/AppContext';
import { parseErrorMessage } from '../utils/error-message';

export const usePersonMutation = (result?: { onError?: () => void; onSuccess?: () => void }) => {
  const { alertError } = useAppContext();
  const queryClient = useQueryClient();

  return useMutation(
    (options: { personId: string; name?: string; isFavorite?: boolean; dateOfBirth?: string }) =>
      backend.patch(`person/${options.personId}`, {
        name: options.name,
        isFavorite: options.isFavorite,
        dateOfBirth: options.dateOfBirth,
      }),
    {
      onError: (e: unknown) => {
        alertError(parseErrorMessage(e));
        result?.onError && result.onError();
      },
      onSuccess: () => {
        queryClient.invalidateQueries(['persons']);
        result?.onSuccess && result.onSuccess();
      },
    },
  );
};
